import { ApprovalVestingTask, VestingTask } from '../types/vesting-tasks.types';
import { toNumber } from './to-number.util';

// Shares a hurdle approval may exercise: vested but not yet exercised. The backend rejects anything
// above this with "Insufficient exercisable shares" (exercisedCount + value > vestedSharesCount), so
// the approval table and the exercise payload must both read the amount from here.
export const getHurdleExercisableShares = ({
  exercisedCount,
  vestedSharesCount,
}: Pick<VestingTask, 'exercisedCount' | 'vestedSharesCount'>): number =>
  Math.max(toNumber(vestedSharesCount) - toNumber(exercisedCount), 0);

type HurdleApprovalTask = Pick<
  ApprovalVestingTask,
  'exercisedCount' | 'requestedSharesCount' | 'vestedSharesCount'
>;

// Never exceed what is exercisable, whatever the admin typed or the stakeholder requested.
export const clampHurdleApprovalShares = (
  vestingTask: Pick<VestingTask, 'exercisedCount' | 'vestedSharesCount'>,
  value: number | string,
): number => Math.min(Math.max(toNumber(value), 0), getHurdleExercisableShares(vestingTask));

// The approval modal defaults each row to the amount the stakeholder requested; rows without an
// originating request (other approvable grants on the plan) default to the full exercisable amount.
export const getHurdleApprovalDefaultShares = (vestingTask: HurdleApprovalTask): number =>
  vestingTask.requestedSharesCount == null
    ? getHurdleExercisableShares(vestingTask)
    : clampHurdleApprovalShares(vestingTask, vestingTask.requestedSharesCount);
